"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _topicService = require("../services/topicService");

var _contentType = require("@insided/shared/utils/contentType");

var _categories = require("@insided/shared/utils/categories");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _publish = _interopRequireDefault(require("../../../../../components/tracker/publish"));

var _Modal = require("@insided/shared/uikit/Modal");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _CategorySelect = _interopRequireDefault(require("@insided/deprecated-control/category-select/CategorySelect"));

var _common = require("@insided/shared/utils/common");

var _string = require("@insided/deprecated-preact-components/utils/string");

var _categoryService = require("../../../Categories/categoryService");

var _logger = require("@insided/shared/services/logger");

var _additionalDescriptio;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var additionalDescriptions = (_additionalDescriptio = {}, (0, _defineProperty2.default)(_additionalDescriptio, _contentType.CONTENT_TYPE_IDEA, 'Please note that idea properties will be lost during this conversion, e.g. pinned reply, ideation status, product areas.'), (0, _defineProperty2.default)(_additionalDescriptio, _contentType.CONTENT_TYPE_QUESTION, 'Please note that question properties will be lost during this conversion, e.g. best answer.'), (0, _defineProperty2.default)(_additionalDescriptio, _contentType.CONTENT_TYPE_ARTICLE, 'Please note that some article properties will be lost during this conversion, e.g. featured image, article label, version history.'), _additionalDescriptio);

var isCategoriesV2Enabled = _common.common.isModuleActive('categoriesV2IdeasAndPU');

var contentTypesWithoutCategory = [_contentType.CONTENT_TYPE_IDEA, _contentType.CONTENT_TYPE_PRODUCT_UPDATE];

var ConvertTopicModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ConvertTopicModal, _PureComponent);

  var _super = _createSuper(ConvertTopicModal);

  function ConvertTopicModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ConvertTopicModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isKnowledgeBaseEnabled", _common.common.isModuleActive('knowledgeBase'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isGroupsEnabled", _common.common.isModuleActive('group'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inFlight", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categoryId: null,
      isLoading: false,
      categoriesV2: {},
      errorMessage: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var categoriesV2;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _categoryService.getCategoriesList)([(0, _categories.getTypeFromModuleName)(_categories.MODULE.COMMUNITY), (0, _categories.getTypeFromModuleName)(_categories.MODULE.KNOWLEDGE_BASE), (0, _categories.getTypeFromModuleName)(_categories.MODULE.GROUPS)]);

            case 2:
              categoriesV2 = _context.sent;

              _this.setState({
                categoriesV2: categoriesV2
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategorySelected", function (categoryId) {
      _this.setState({
        categoryId: categoryId !== null && categoryId !== void 0 ? categoryId : null,
        errorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "convertTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props, topicId, fromContentType, toContentType, onShowAlert, _this$state, categoryId, categoriesV2;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.inFlight) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _this$props = _this.props, topicId = _this$props.topicId, fromContentType = _this$props.fromContentType, toContentType = _this$props.toContentType, onShowAlert = _this$props.onShowAlert;
              _this$state = _this.state, categoryId = _this$state.categoryId, categoriesV2 = _this$state.categoriesV2;

              if (!(categoriesV2 && contentTypesWithoutCategory.includes(fromContentType) && !categoryId)) {
                _context2.next = 8;
                break;
              }

              _this.setState({
                errorMessage: "Please select a category".concat(_this.isGroupsEnabled ? ' or group' : '')
              });

              _this.inFlight = false;
              return _context2.abrupt("return");

            case 8:
              // set sync guard immediately
              _this.inFlight = true;

              _this.setState({
                isLoading: true
              });

              _context2.prev = 10;
              _context2.next = 13;
              return (0, _topicService.convert)(fromContentType, topicId, toContentType, categoryId !== null && categoryId !== void 0 ? categoryId : undefined);

            case 13:
              _publish.default.trackEvent('userevent', {
                type: 'Topic converted',
                'Converted from content type': fromContentType,
                'Converted to content type': toContentType,
                event_source: 'control',
                userid: (0, _insidedDataStorage.getInsidedData)('user').userid
              });

              _context2.next = 16;
              return _this.redirectAfterConversion();

            case 16:
              _context2.next = 23;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](10);

              _logger.logger.error(_context2.t0, {
                component: 'ConvertTopicModal',
                action: 'convertTopic'
              });

              onShowAlert('error');

              _this.setState({
                isLoading: false
              });

            case 23:
              _context2.prev = 23;
              _this.inFlight = false;
              return _context2.finish(23);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[10, 18, 23, 26]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "redirectAfterConversion", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props2, toContentType, publicId, onShowAlert, setMessage, hideModal, hasError, tryCount, newContentType;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props2 = _this.props, toContentType = _this$props2.toContentType, publicId = _this$props2.publicId, onShowAlert = _this$props2.onShowAlert, setMessage = _this$props2.setMessage, hideModal = _this$props2.hideModal;
              hasError = false;
              tryCount = 0;

            case 3:
              if (!(tryCount < 10)) {
                _context3.next = 28;
                break;
              }

              _context3.prev = 4;
              _context3.t0 = _contentType.getConsistentContentType;
              _context3.next = 8;
              return (0, _topicService.getContentType)(publicId);

            case 8:
              _context3.t1 = _context3.sent;
              newContentType = (0, _context3.t0)(_context3.t1);

              if (!(newContentType === toContentType)) {
                _context3.next = 16;
                break;
              }

              _this.setState({
                isLoading: false
              });

              window.location.reload();
              return _context3.abrupt("return");

            case 16:
              _context3.next = 18;
              return new Promise(function (resolve) {
                return window.setTimeout(resolve, 1000);
              });

            case 18:
              _context3.next = 25;
              break;

            case 20:
              _context3.prev = 20;
              _context3.t2 = _context3["catch"](4);

              _logger.logger.error(_context3.t2, {
                component: 'ConvertTopicModal',
                action: 'redirectAfterConversion'
              });

              hasError = true;
              return _context3.abrupt("break", 28);

            case 25:
              tryCount++;
              _context3.next = 3;
              break;

            case 28:
              if (hasError) {
                onShowAlert('error');

                _this.setState({
                  isLoading: false
                });
              } else {
                setMessage((0, _preact.h)("div", null, "Sorry, the topic conversion is taking a bit longer than expected. Please try ", (0, _preact.h)("a", {
                  href: ""
                }, "refreshing"), " the page."));
                hideModal();
              }

            case 29:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 20]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(ConvertTopicModal, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          fromContentType = _this$props3.fromContentType,
          toContentType = _this$props3.toContentType,
          hideModal = _this$props3.hideModal;
      var _this$state2 = this.state,
          categoryId = _this$state2.categoryId,
          categoriesV2 = _this$state2.categoriesV2,
          errorMessage = _this$state2.errorMessage,
          isLoading = _this$state2.isLoading;
      var formattedFrom = (0, _string.addSpacesAndLowerCase)(fromContentType);

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      var isConvertingToBug = isBugContentTypeEnabled && toContentType === _contentType.CONTENT_TYPE_CONVERSATION;
      var formattedTo = isConvertingToBug ? 'bug' : (0, _string.addSpacesAndLowerCase)(toContentType);
      var showCategorySelect = categoriesV2 && isCategoriesV2Enabled ? categoryId === null : contentTypesWithoutCategory.includes(fromContentType);
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: true,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Convert ".concat(formattedFrom, " to ").concat(formattedTo),
        onClose: hideModal
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
        className: "convert-topic-description"
      }, (0, _preact.h)("p", null, "Are you sure that you want to convert this ", formattedFrom, " to ", (0, _string.getIndefiniteArticle)(toContentType), ' ', formattedTo, "?"), fromContentType in additionalDescriptions && (0, _preact.h)("p", null, additionalDescriptions[fromContentType]), showCategorySelect && (0, _preact.h)(_InputGroup.default, {
        title: "Publish the converted topic in",
        id: "select-category",
        error: errorMessage,
        customInput: (0, _preact.h)(_CategorySelect.default, {
          onUpdate: this.onCategorySelected,
          categories: categoriesV2,
          categoryId: categoryId,
          error: errorMessage,
          isKnowledgeBaseEnabled: isConvertingToBug ? false : this.isKnowledgeBaseEnabled,
          isGroupsEnabled: isConvertingToBug ? false : this.isGroupsEnabled,
          categoryV2Allowed: true,
          hideLabel: true
        }),
        showIconBeforeErrorMessage: true
      }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: "Convert",
        onClick: this.convertTopic,
        variant: "primary",
        size: "medium",
        isLoading: isLoading,
        disabled: isLoading,
        type: "submit",
        className: "qa-convert-topic"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: hideModal,
        size: "medium"
      })));
    }
  }]);
  return ConvertTopicModal;
}(_preactCompat.PureComponent);

var _default = ConvertTopicModal;
exports.default = _default;